export default __webpack_public_path__ + "static/media/3.397c8e2c.png";